import useApi from "@/hooks/useApi";
import React, { useCallback, useEffect, useState } from "react";
import { WorkflowListItem } from "@/pages/Messaging/Workflows/types";
import { WorkflowsContext } from "@/context/WorkflowsContext";

export function WorkflowsProvider(props: { children: React.ReactNode }) {
  const [workflows, setWorkflows] = useState<WorkflowListItem[]>([]);
  const api = useApi();

  const fetch = useCallback(async () => {
    try {
      const response = await api.messaging.get("Workflows/List");
      const data = await response.json();
      setWorkflows(Array.isArray(data) ? data : []);
    } catch {
      setWorkflows([]);
    }
  }, [api.messaging]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <WorkflowsContext.Provider
      value={{
        workflows,
        setWorkflows,
        fetch
      }}
    >
      {props.children}
    </WorkflowsContext.Provider>
  );
}
